module.exports = __webpack_public_path__ + "img/GALLERY-CIAZ-4.809813d1.jpg";